import * as React from 'react';
import styles from './index.less';
import { Progress, Space } from 'antd';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, StorageHomePageModelState } from '@/models/connect';
import { DeleteBucketByNameAction } from '@/models/storageHomePage';
import FTooltip from '@/components/FTooltip';
import fMessage from '@/components/fMessage';
import FLink from '@/components/FLink';
import { FUtil, FI18n } from '@freelog/tools-lib';
import { history } from 'umi';
import FComponentsLib from '@freelog/components-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import FIcons from '@/components/FIcons';
import FButton from '@/components/FButton';

interface SiderProps {
  dispatch: Dispatch;
  storageHomePage: StorageHomePageModelState;
}

function Sider({ storageHomePage, dispatch }: SiderProps) {
  const customBuckets = (storageHomePage.bucketList || []).filter((b) => b.bucketType === 1);
  const systemBuckets = (storageHomePage.bucketList || []).filter((b) => b.bucketType === 2);

  return (
    <>
      <div className={styles.sider}>
        <div>
          <div style={{ height: 30 }} />
          <div className={styles.title}>
            <Space size={10}>
              <FComponentsLib.FTitleText
                text={
                  // 我的存储空间
                  FI18n.i18nNext.tAuto('my_buckets')
                }
                type='h4'
              />
              <FComponentsLib.FTitleText
                text={`${(storageHomePage.bucketList || []).length}/5`}
                type='h4'
              />
            </Space>

            {(storageHomePage.bucketList || []).length < 5 ? (
              <FButton.FCircleBtn
                type='transparent'
                onClick={() => {
                  history.replace(
                    FUtil.LinkTo.storageSpace({
                      bucketName: storageHomePage.activatedBucket,
                      createBucket: true,
                    }),
                  );
                }}
              />
            ) : (
              <FTooltip
                title={FI18n.i18nNext.tAuto('msg_bucket_quantity_exceed')}
                trigger='click'
                placement='topLeft'
              >
                <FButton.FCircleBtn type='transparent' />
              </FTooltip>
            )}
          </div>
          <div style={{ height: 30 }} />
          {customBuckets.length > 0 ? (
            <div className={styles.navs}>
              {customBuckets.map((b) => {
                return (
                  <FLink
                    replace
                    key={b.bucketName}
                    className={
                      storageHomePage.activatedBucket === b.bucketName ? styles.activated : ''
                    }
                    to={FUtil.LinkTo.storageSpace({
                      bucketName: b.bucketName,
                    })}
                  >
                    <FTooltip
                      title={b.bucketName}
                      // getPopupContainer={() => containerRef.current}
                      trigger='hover'
                      // open={l.disabled ? undefined : false}
                    >
                      <div
                        style={{
                          maxWidth: 140,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {b.bucketName}
                      </div>
                    </FTooltip>
                    <FTooltip
                      title={FI18n.i18nNext.tAuto('tip_delete')}
                      mouseEnterDelay={0.3}
                    >
                      <FIcons.FDelete
                        onClick={async (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          // console.log('@#@#$dsiofud890saufoisdajfl;sd');
                          if (b.totalFileQuantity === 0) {
                            const bool: boolean = await fPromiseModalConfirm({
                              title: '提示',
                              description: FI18n.i18nNext.t('msg_delete_object_confirm'),
                              okText: FI18n.i18nNext.t('btn_delete_object'),
                              cancelText: FI18n.i18nNext.t('btn_cancel'),
                            });
                            if (bool) {
                              dispatch<DeleteBucketByNameAction>({
                                type: 'storageHomePage/deleteBucketByName',
                                payload: b.bucketName,
                              });
                            }
                            // fConfirmModal({
                            //   message: FI18n.i18nNext.tAuto('msg_delete_object_confirm'),
                            //   okText: FI18n.i18nNext.tAuto('btn_delete_object'),
                            //   cancelText: FI18n.i18nNext.tAuto('btn_cancel'),
                            //   onOk() {
                            //     dispatch<DeleteBucketByNameAction>({
                            //       type: 'storageHomePage/deleteBucketByName',
                            //       payload: b.bucketName,
                            //     });
                            //   },
                            // });
                          } else {
                            fMessage('该存储空间内还有未删除模拟资源', 'warning');
                          }
                        }}
                        className={styles.bucketDeleteBtn}
                      />
                    </FTooltip>
                  </FLink>
                );
              })}
            </div>
          ) : (
            <div style={{ padding: '0 40px' }}>
              <FComponentsLib.FContentText
                type='additional2'
                // text={'单击“ + ”创建您的第一个项目。'}
                text={FI18n.i18nNext.tAuto('my_buckets_list_empty')}
              />
            </div>
          )}
        </div>

        <div className={styles.statistics}>
          <Progress
            size={['100%', 6]}
            percent={(storageHomePage.usedStorage / storageHomePage.totalStorage) * 100}
            showInfo={false}
            className={styles.progressBack}
          />
          <div className={styles.ratio}>
            {FUtil.Format.humanizeSize(storageHomePage.usedStorage)} /{' '}
            {FUtil.Format.humanizeSize(storageHomePage.totalStorage)}
          </div>

          {systemBuckets.length > 0 && (
            <>
              <div style={{ height: 60 }} />

              <div className={styles.title}>
                <FComponentsLib.FTitleText text={'系统存储空间'} type='h4' />
              </div>

              {/*<div style={{height: 18}}/>*/}
              {/*<div className={styles.buckets}>*/}
              {/*  <a*/}
              {/*    className={storage.activatedBucket === '.UserNodeData' ? styles.bucketActive : ''}*/}
              {/*    onClick={() => dispatch<OnChangeActivatedBucketAction>({*/}
              {/*      type: 'storageHomePage/onChangeActivatedBucket',*/}
              {/*      payload: '.UserNodeData',*/}
              {/*    })}>.Nodedata</a>*/}
              {/*</div>*/}
            </>
          )}
          <div style={{ height: 40 }} />
        </div>
      </div>
    </>
  );
}

export default connect(({ storageHomePage }: ConnectState) => ({
  storageHomePage: storageHomePage,
}))(Sider);
